import { checkUsername } from 'src/app/pages/wizard/vuex/actions'
import { checkCep } from 'src/app/pages/settings/vuex/actions'
import date from 'src/utils/date'
import { checkCpf, verifyEmail } from '../app/pages/subscribe/vuex/actions'
import Rules from 'src/rules'

export default {
  validations (context) {
    return {
      usernameFormat: {
        getMessage: (field, args) => context.$t('application.validators.usernameFormat.seller.username'),
        validate: (value, args) => new Promise(resolve => {
          if (value === undefined || value.toString().length === 0) return
          resolve({ valid: value.match(/^[a-zA-Z0-9-]+$/) })
        })
      },
      phone: {
        getMessage: (field, args) => context.$t('application.validators.phone'),
        validate: (value, args) => new Promise(resolve => {
          let phone = value.toString().replace(/\D/g, '')
          resolve({valid: phone.length > 9})
        })
      },
      valid_quantity: {
        getMessage: (field, args) => context.$t('application.validators.invalid_quantity', { quantity: args[0] }),
        validate: (value, args) => new Promise(resolve => {
          resolve({ valid: parseInt(value) > args[0] || parseInt(value) === 0 || args[0] === undefined || (parseInt(args[0]) === parseInt(args[1]) && parseInt(value) === parseInt(args[1])) })
        })
      },
      max_quantity: {
        getMessage: (field, args) => context.$t('application.validators.quantity_greater_than_allowed'),
        validate: (value, args) => new Promise(resolve => {
          resolve({ valid: parseInt(value) < 1000 })
        })
      },
      onlyPositive: {
        getMessage: (fields, args) => context.$t('application.validators.positive'),
        validate: (value, args) => new Promise(resolve => {
          resolve({ valid: value >= 0 })
        })
      },
      percentage: {
        getMessage: (fields, args) => context.$t('application.validators.percentage'),
        validate: (value, args) => new Promise(resolve => {
          resolve({ valid: value > 0 && value <= 100 })
        })
      },
      uniqUsername: {
        getMessage: (field, args) => context.$t('application.validators.uniqUsername.seller.username'),
        validate: (value, args) => new Promise(resolve => {
          if (value === undefined || value.toString().length === 0) return
          checkUsername(context, value).then(function (response) {
            resolve({ valid: response && response.status === 200 })
          })
        })
      },
      cpf: {
        getMessage: (field, args) => context.$t('application.validators.validCpf.cpf'),
        validate: (value, args) => Rules.cpf(value)
      },
      cpfInUse: {
        getMessage: (field, args) => context.$t('subscribe.attributes.cpf_in_use'),
        validate: (value, args) => new Promise(resolve => {
          if (value === undefined || value.toString().length === 0) return
          const cpf = value.replace(/\D/g, '')
          if (window.localStorage.customerCPF) {
            let customerCPF = JSON.parse(window.localStorage.customerCPF)
            checkCpf(context, cpf).then(function (response) {
              resolve({valid: cpf === customerCPF || response.status !== 200})
            })
          } else {
            checkCpf(context, cpf).then(function (response) {
              resolve({valid: response.status !== 200})
            })
          }
        })
      },
      emailInUse: {
        getMessage: (field, args) => context.$t('application.validators.validEmail.email'),
        validate: (value, args) => new Promise(resolve => {
          if (value === undefined || value.toString().length === 0) return
          if (window.localStorage.customerEmail) {
            let email = JSON.parse(window.localStorage.customerEmail)
            verifyEmail(context, value).then(function (response) {
              resolve({valid: value === email || response.status !== 200})
            })
          } else {
            verifyEmail(context, value).then(function (response) {
              resolve({valid: response.status !== 200})
            })
          }
        })
      },
      cnpj: {
        getMessage: (field, args) => context.$t('application.validators.validCnpj.cnpj'),
        validate: (value, args) => Rules.cnpj(value)
      },
      cep: {
        getMessage: (field, args) => context.$t('application.validators.cep.invalid'),
        validate: (value, args) => new Promise(resolve => {
          if (value === undefined || value.toString().length === 0) return
          const cep = value.replace(/\D/g, '')
          checkCep(context, cep).then(function (response) {
            resolve({ valid: response.status === 200 })
          })
        })
      },
      date: {
        getMessage: (field, args) => context.$t('application.validators.date.past'),
        validate (value, args) {
          if (value === undefined) return false

          const valueDate = value.toString().split('-')
          const transformedDate = new Date(valueDate)
          const dateCurrent = date.parseInternationalDate(new Date())
          const informedDate = date.parseInternationalDate(transformedDate)
          if (value === undefined || informedDate < dateCurrent) return false
          return true
        }
      },
      valid_dd: {
        getMessage: (field, args) => context.$t('application.validators.day_expiration'),
        validate: (value, args) => new Promise(resolve => {
          resolve({ valid: value > 0 && value < 32 })
        })
      },
      valid_mm_yyyy: {
        getMessage: (field, args) => context.$t('application.validators.date.past'),
        validate (value, args) {
          if (value.length <= 6) return true
          if (value === undefined) return false
          const currentDate = new Date()
          const currentDay = currentDate.getDate()
          const valueDate = value.toString().split('/')
          const formatedDate = valueDate[1] + '-' + valueDate[0] + '-' + currentDay
          const createDate = formatedDate.toString().split('-')
          const transformedDate = new Date(createDate)
          const dateCurrent = date.parseInternationalDate(new Date())
          const inputDate = date.parseInternationalDate(transformedDate)
          if (dateCurrent > inputDate) return false
          return true
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/validators.js